// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"9989e907","319":"902f2627","407":"cf6df1de","679":"75c42578","793":"4b061220","988":"e5f5e80e"}[chunkId] + ".chunk.js";
};